import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './Text.module.scss';

const propTypes = {
  /**
   * Tag type
   */
  as: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'p',
    'span',
    'div'
  ]),

  /**
   * Align text
   */
  align: PropTypes.oneOf([
    'left',
    'right',
    'center'
  ]),

  /**
   * Text size
   */
  textSize: PropTypes.oneOf([
    'textXlRegular',
    'textLgRegular',
    'textSmRegular'
  ]),

  /**
   * Extra classes
   */
  classname: PropTypes.string,

  /**
   * Text contents
   */
  contents: PropTypes.string.isRequired,

  /**
   * Additional Styles for component
   */
  style: PropTypes.object
};

const defaultProps = {
  as: 'p',
  align: 'left'
};

/**
 * Text component
 */
const Text = ({
  as,
  align,
  textSize,
  classname,
  contents,
  style
}) => {
  // @TODO:REMOVE

  const Component = as;

  return (
    <Component
      className={`${classname ? classname : ''} 
          ${styles[align]} 
          ${textSize ? styles[textSize] : ''}`}
      style={style}
      dangerouslySetInnerHTML={{
        __html: contents
      }}/>
  );
};

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
